import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { getKeyHandler } from '../structure/FlowForm';
import { globalBlur } from '../helpers/dom';
import './Checkbox.css';
// SVG for checked state
const CheckedSVG = () => (_jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M1.73,12.91 8.1,19.28 22.79,4.59", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round", style: { strokeDasharray: 30 } }) }));
// SVG for checkbox with cross
const CheckboxSVG = () => (_jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M6 18L18 6M6 6L18 18", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }) }));
// SVG for radio button with circle
const RadioSVG = () => (_jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("circle", { cx: "12", cy: "12", r: "9", strokeWidth: "1", strokeLinecap: "round", strokeLinejoin: "round" }) }));
const Checkbox = ({ checked = false, disabled = false, animated = true, sidewaysFocus = false, sidewaysBehaviour = 'both', type = 'checkbox', focussable = 'flow', onFocus, onToggle, rejectFocus, size = 'normal' }) => {
    const ref = React.useRef(null);
    const handleKeyDown = getKeyHandler({
        enterBehaviour: 'action',
        spaceBehaviour: 'action',
        sidewaysBehaviour: sidewaysFocus ? sidewaysBehaviour : 'both',
        onAction: () => disabled || (onToggle === null || onToggle === void 0 ? void 0 : onToggle(!checked))
    });
    const handleClick = (ev) => {
        ev.preventDefault();
        if (disabled)
            return;
        if (rejectFocus)
            globalBlur();
        else {
            const el = ev.currentTarget;
            el === null || el === void 0 ? void 0 : el.focus();
        }
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(!checked);
        return true;
    };
    return (_jsxs("button", { ref: ref, tabIndex: (disabled || focussable == 'off') ? -1 : 0, onClick: handleClick, onKeyDown: handleKeyDown, onFocus: onFocus, className: `flowCheckmark${animated ? ' animated' : ''} ${checked ? 'checked' : 'unchecked'}${disabled ? ' disabled' : ' enabled'} ${(focussable == 'flow' && !disabled) ? 'flowFocussable' : ''} ${sidewaysFocus ? ' sidewayFocus' : ''} ${type} ${size}`, children: [checked && type == 'checkmark' && _jsx(CheckedSVG, {}), checked && type == 'checkbox' && _jsx(CheckboxSVG, {}), !checked && type != 'radio' && _jsx("div", {}), type == 'radio' && _jsx(RadioSVG, {})] }));
};
export default Checkbox;
